module.exports = __webpack_public_path__ + "img/tombstone.ec91942f.svg";